import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PagedResult } from '../models/product.models';
import {
  EmployeeDto,
  CreateEmployeeRequest,
  UpdateEmployeeRequest,
  CreateEmployeeResponse,
  WorkScheduleDto,
  SaveWorkScheduleRequest,
} from '../models/employee.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class EmployeeService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/Employee`;

  getAll(
    page: number,
    pageSize: number,
    search?: string,
  ): Observable<ApiResponse<PagedResult<EmployeeDto>>> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search) params = params.set('search', search);
    return this.http.get<ApiResponse<PagedResult<EmployeeDto>>>(this.endpoint, { params });
  }

  create(data: CreateEmployeeRequest): Observable<ApiResponse<CreateEmployeeResponse>> {
    return this.http.post<ApiResponse<CreateEmployeeResponse>>(this.endpoint, data);
  }

  update(id: string, data: UpdateEmployeeRequest): Observable<ApiResponse<unknown>> {
    return this.http.put<ApiResponse<unknown>>(`${this.endpoint}/${id}`, data);
  }

  delete(id: string): Observable<ApiResponse<unknown>> {
    return this.http.delete<ApiResponse<unknown>>(`${this.endpoint}/${id}`);
  }

  assignStores(id: string, storeIds: string[]): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(`${this.endpoint}/${id}/assign-stores`, {
      storeIds,
    });
  }

  assignPermissions(id: string, permissionKeys: string[]): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(`${this.endpoint}/${id}/assign-permissions`, {
      permissionKeys,
    });
  }

  regeneratePin(id: string): Observable<ApiResponse<{ pinCode?: string; pin?: string }>> {
    return this.http.post<ApiResponse<{ pinCode?: string; pin?: string }>>(
      `${this.endpoint}/${id}/regenerate-pin`,
      {},
    );
  }

  getWorkSchedule(id: string): Observable<ApiResponse<WorkScheduleDto | null>> {
    return this.http.get<ApiResponse<WorkScheduleDto | null>>(`${this.endpoint}/${id}/schedule`);
  }

  saveWorkSchedule(id: string, data: SaveWorkScheduleRequest): Observable<ApiResponse<unknown>> {
    return this.http.put<ApiResponse<unknown>>(`${this.endpoint}/${id}/schedule`, data);
  }
}
